import React, { useMemo } from 'react';
import { formatPctDelta } from './overviewCompute';
import { computeImagingTab } from './overviewImagingCompute';

function Card({ label, big, lines }) {
  return (
    <div className="overview-box overview-tile">
      <small className="overview-tile-label">{label}</small>
      <div className="overview-big">{big}</div>
      {lines.map((line, i) => (
        <div key={i} className="overview-tile-line">{line}</div>
      ))}
    </div>
  );
}

function OverviewImagingTab({
  studiesCurrent,
  studiesPrior,
  faxesCurrent,
  vitalroundsCurrent,
  vitalroundsPrior,
  referralsCurrent,
  facIds,
  metrics,
  loading,
}) {
  const stats = useMemo(
    () => computeImagingTab({
      studiesCurrent,
      studiesPrior,
      faxesCurrent,
      vitalroundsCurrent,
      vitalroundsPrior,
      referralsCurrent,
      hubFacIds: facIds,
      metricsStudies: metrics?.current?.studies,
      metricsStudiesPrior: metrics?.previous?.studies,
      metricsRounds: metrics?.current?.vitalRounds,
      metricsRoundsPrior: metrics?.previous?.vitalRounds,
    }),
    [
      studiesCurrent, studiesPrior, faxesCurrent, vitalroundsCurrent,
      vitalroundsPrior, referralsCurrent, facIds, metrics,
    ]
  );

  if (loading) return <div className="overview-loading">Loading imaging & fax…</div>;

  const stuDelta = formatPctDelta(stats.studiesDelta);
  const rndDelta = formatPctDelta(stats.roundsDelta);

  return (
    <div className="overview-grid3">
      <Card
        label="DICOM STUDIES · YTD"
        big={stats.studiesTotal.toLocaleString()}
        lines={[
          <span key="d" className={`overview-delta ${stuDelta.kind}`}>{stuDelta.text}</span>,
          <span key="io">{stats.studiesIn.toLocaleString()} in · {stats.studiesOut.toLocaleString()} out</span>,
          <span key="dicom">
            {Math.round(stats.dicomShare * 100)}% of referrals carry DICOM ({stats.withDicom.toLocaleString()})
          </span>,
        ]}
      />
      <Card
        label="PACS CONNECTION"
        big="—"
        lines={[
          <span key="m" className="muted">No PACS / DICOM outbound status in cache</span>,
        ]}
      />
      <Card
        label="VFAX · WINDOW"
        big={`${stats.faxPages.toLocaleString()} pages`}
        lines={[
          <span key="c">{stats.faxCount.toLocaleString()} fax record{stats.faxCount === 1 ? '' : 's'}</span>,
          <span key="e">
            {stats.externalSender.toLocaleString()} referrals from non-VE senders (proxy, not “converted”)
          </span>,
        ]}
      />
      <Card
        label="EMR DIRECT PUSH"
        big="—"
        lines={[
          <span key="m" className="muted">No EMR push feed in VitalData cache</span>,
        ]}
      />
      <Card
        label="QUICK REFER LINKS"
        big={`${stats.quickRefer.toLocaleString()} referrals`}
        lines={[
          <span key="q">referral_type = 3 in this window</span>,
          <span key="n" className="muted">Active link inventory not stored in API</span>,
        ]}
      />
      <Card
        label="VITALROUNDS"
        big={`${stats.rounds.toLocaleString()} conferences`}
        lines={[
          <span key="d" className={`overview-delta ${rndDelta.kind}`}>{rndDelta.text}</span>,
        ]}
      />
    </div>
  );
}

export default OverviewImagingTab;
